<app-chart
  *ngIf='openChart'
  (onCloseChartToParent)='closeChartModals()'
  [ChartData]="chartData"
  [subTitle]="subtitle"
  [universalAuditID]="universalAuditID"
  [component]="component"></app-chart>
<span nglDropdown [(open)]="openBtnRateIntegrity">
  <section class="overAuditGrid">&nbsp;
  <div class="leftControls">
    <span class="cvt-primary rvrs-new-audit cvt-icon-addCircleFilled  " nglDropdownTrigger> </span>
  </div>
  <div class="slds-dropdown slds-dropdown--left rvrs-drpdwn k-primary ">
    <ul class="" role="menu">
      <li class="" *ngFor="let item of auditCreateMapping;">
        <a [routerLink]="[item.path]" role="menuitem" (click)="openBtnRateIntegrity=false;">
          <p class="slds-truncate rvrs-para">{{item.text}}</p>
        </a>
      </li>
    </ul>
  </div>
  </section>
</span>

<div class="auditGrid">
  <kendo-grid id="kendoGrid"
                [data]="view"
                [pageSize]="state.take"
                [pageable]="{buttonCount: 5}"
                [skip]="state.skip"
                [sort]="state.sort"
                [sortable]="true"
                [pageable]="true"
                [scrollable]="'none'"
                (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="UniversalAuditID" id="UniversalAuditID" title="Audit ID"  >
      <ng-template kendoGridHeaderTemplate  let-column>
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
        <span style="display: none;">{{ column.field | json}} {{this.sorted | json}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [width]="150">
        <ng-template kendoGridHeaderTemplate  let-column>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<span >&emsp;&emsp;&nbsp;</span>
          </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
        <div class="raui-grid-buttons raui-nowrap">
          <a src="#" (click)="displayChart($event, dataItem)" title="View Chart">
            <span class="cvt-icon-reports grid-cmd-icons"></span>
          </a>
          <a src="#" title="Reports" (click)="onShowReports(dataItem.AuditRvrID)"><span class="cvt-icon-document grid-cmd-icons"></span></a>
          <a [routerLink]="['../review', {auditId:dataItem.AuditID,auditRvrId:dataItem.AuditRvrID, universalId:dataItem.UniversalAuditID, accountName:dataItem.CustomerAccountID}]"  title="Notification"><span class="cvt-icon-htmlEmail grid-cmd-icons"></span></a>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ScheduledRunDate" title="Scheduled Run Time" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{  dataItem.ScheduledRunDate | date:'medium'  }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="PickedUpForProcessing" title="Processing Started" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{  dataItem.PickedUpForProcessing | date:'medium'  }}
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{  dataItem.PickedUpForProcessing | date:'medium'  }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ProcessingCompleted" title="Processing Completed" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{  dataItem.ProcessingCompleted | date:'medium'  }}
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{  dataItem.ProcessingCompleted | date:'medium'  }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="CustomerAccountID" title="Customer Account ID" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column-group [locked]="false" [width]="200" headerClass="raui-gds-audited-hd"  >
      <kendo-grid-column field="AuditAmadeus" title="Amadeus" headerClass="raui-gds-audited" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem.AuditAmadeus" class="cvt-icon-check grid-status-icons"></span>
          <span *ngIf="!dataItem.AuditAmadeus">&nbsp;</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AuditApollo" title="Apollo" headerClass="raui-gds-audited" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem.AuditApollo" class="cvt-icon-check grid-status-icons"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AuditGalileo" title="Galileo" headerClass="raui-gds-audited" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem.AuditGalileo" class="cvt-icon-check grid-status-icons"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AuditSabre" title="Sabre" headerClass="raui-gds-audited" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem.AuditSabre" class="cvt-icon-check grid-status-icons"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AuditWorldspan" title="Worldspan" headerClass="raui-gds-audited" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span *ngIf="dataItem.AuditWorldspan" class="cvt-icon-check grid-status-icons"></span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid-column-group>
    <kendo-grid-column field="NotificationTemplate" title="Notifications" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="StatusStr" title="Status" >
      <ng-template kendoGridHeaderTemplate  let-column >
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
<app-report-dialog *ngIf="showReportDialog" [AuditId]="reportDlgAuditId" [AuditType]="'reverseAudit'" (done)="reportDialogDone()"></app-report-dialog>
